<router-outlet></router-outlet>
<div id="globalServiceLoader">
  <div class="loader"></div>
  <div class="icon">
    <mzic-svg src="assets/icons/mzic-check-mark.svg" class="stroke w34 green" />
  </div>
</div>
